import React, { Component } from 'react'
import ConsultaCrud from '../../../../../components/ConsultaCrud'


import { apiSalveInColection, apiDeleteInColection, apiSyncReducer } from 'scorpion-core';
import { FiltroStringScorpion } from 'scorpion-core'
import firebase from 'firebase/app';
import { prodConfig1 } from '../../../../../ConfigAplication'
var secondaryApp = firebase.initializeApp(prodConfig1, "Secondary");

import View from 'react-flexbox'

import { DialogPesquisa } from "scorpion-core";
import DinamicCrudCustomFormDialog from '../DinamicCrudCustomFormDialog';
import { Typography } from '@material-ui/core';

export default class DinamicCrudCustomConsulta extends Component {
    constructor(props) {
        super(props)
        this.state = { itemEditar: null }
    }
    componentDidMount() {
        this.props.listar(this.props.customForm);

    }

    copiarParaOkProjects(value) {
        console.log("copiarParaOkProjects", value);
        const firestore = secondaryApp.firestore();
        const settings = {/* your settings... */ timestampsInSnapshots: true };
        firestore.settings(settings);
        let cols = firestore.collection("ValueCustomForm").doc("TicketEvop").collection("Values");
        console.log("cols", cols);
        value.forEach(v => {
            console.log("v", v);

            apiSalveInColection(cols, v)
        })



    }
    render() {
        const { history, colunas, titulo, listaPesquisa, loading, customForm, editarEmDialog, botoesAntes, descricaoFiltroCodigo } = this.props;
        const { itemEditar } = this.state;
        const tipoModeloRelatoriosUnico = customForm.uid + "Unico"
        const tipoModeloRelatoriosMultipos = customForm.uid + "Multiplo"

        const novo = () => history.push("/" + customForm.rota);
        // const novo = () => this.copiarParaOkProjects(this.props.listaPesquisa);
        let editar = (obj) => history.push({ pathname: "/" + customForm.rota, state: { uidItem: obj.uid } })
        if (editarEmDialog) {
            editar = (obj) => this.setState({ itemEditar: obj }, () => this.dialog.show())
        }


        let styleFiltros = { flex: 1, padding: 5 }
        let filtros = []
        if (colunas)
            colunas.forEach(col => {
                if (col.renderFiltro) {
                    let CompRender = col.renderFiltro
                    filtros.push(<CompRender key={col.id} col={col} listaPesquisa={listaPesquisa} />)
                } else
                    if (col.filtro) {
                        filtros.push(<FiltroStringScorpion key={col.id} name={"filtro" + col.id} label={col.label}
                            style={styleFiltros}
                            strComparaLike={item => col.getValue(item) + ""}
                            criaSugestaoPorLike={listaPesquisa} />)
                    }
            });


        return (
            <View >
               
                <ConsultaCrud
                    titulo={descricaoFiltroCodigo||titulo}
                    tipoModeloRelatoriosUnico={tipoModeloRelatoriosUnico}
                    tipoModeloRelatoriosMultipos={tipoModeloRelatoriosMultipos}
                    loading={loading}
                    lista={listaPesquisa}
                    colunas={colunas}
                    editar={editar}
                    novo={novo}
                    botoesAntes={botoesAntes}
                >
                    {filtros}
                </ConsultaCrud>

                <DialogPesquisa forwardedRef={node => this.dialog = node} >
                    <DinamicCrudCustomFormDialog initialValues={itemEditar} sair={() => { this.dialog.hide(); }} customFormUid={customForm.uid} />
                </DialogPesquisa>
            </View>
        )
    }
}



// WEBPACK FOOTER //
// ./src/routes/sistema/DinamicForms/components/DinamicCrudCustomConsulta/DinamicCrudCustomConsulta.js